import type { AgentSearchLocation } from '../types';

export const formatLocationTitle = (location: AgentSearchLocation): string => {
  return location.zipCode
    ? `${location.city}, ${location.state} ${location.zipCode}`
    : `${location.city}, ${location.state}`;
};
